<template>
  <teleport to="body"
    ><base-dialog
      @toggleVisibility="toggleVisibility"
      v-if="openModal"
      :position="position"
      :mode="mineralData.mineralGroup"
    >
      <mineral-group
        v-if="mineralData.mineralGroup"
        :details="mineralData"
      ></mineral-group>
      <div v-else class="oneMineral">
        <single-mineral
          :details="mineralData.minerals"
        ></single-mineral></div></base-dialog
  ></teleport>

  <div class="loading" v-if="isLoading && !noMatch">
    <base-spinner></base-spinner>
  </div>

  <NoMatch v-if="noMatch === true" @toggle-match="handleCloseOneRock" />

  <!--CONTENT-->
  <div class="content" v-if="!isLoading && !noMatch">
    <close-button @click="handleCloseOneRock" mode="details"></close-button>
    <div class="title">
      <div class="title_name">
        <h1>{{ oneRock.name.propValue }}</h1>
      </div>
      <div class="title_detail">{{ oneRock.type.propValue }}</div>
    </div>
    <div class="left">
      <div class="left--photo">
        <base-photo
          :image-data="
            Object.assign(oneRock, {
              size: 'medium',
              source: '/img/rocks/' + oneRock.idName.replace(/\W/g, ''),
            })
          "
        />
      </div>
    </div>
    <div class="right">
      <div class="right--subitems" v-if="oneRock.neworigin.propValue">
        <div class="subitem--heading">
          {{ oneRock.neworigin.propName }}
        </div>

        <div
          v-for="[key, value] of Object.entries(oneRock.neworigin.propValue)"
          :key="value"
        >
          {{ key }}: {{ value }}
        </div>
      </div>

      <div
        class="right--subitems"
        v-if="oneRock.grain.min || oneRock.grain.max || oneRock.grain.other"
      >
        <div class="subitem--heading">{{ oneRock.grain.propName }}</div>
        <div>
          <span v-if="oneRock.grain.min"
            >{{ replaceSymbols(oneRock.grain.min.signal) }}
            {{ oneRock.grain.min.value }} mm<span v-if="oneRock.grain.max">
              ~
            </span></span
          >
          <span class="mm" v-if="oneRock.grain.max"
            >{{ replaceSymbols(oneRock.grain.max.signal) }}
            {{ oneRock.grain.max.value }} mm</span
          >
        </div>
        <div v-if="oneRock.grain.other">{{ oneRock.grain.other }}</div>
      </div>

      <div class="right--subitems">
        <div class="subitem--heading">{{ oneRock.composition }}</div>
        <div
          class="subitem--detail"
          v-if="oneRock.composition_essential.propValue"
        >
          <span>{{ oneRock.composition_essential.propName }}: </span>
          <template
            :key="min"
            v-for="min in replaceString(
              oneRock.composition_essential.propValue,
            )"
          >
            <span
              class="min_else"
              v-if="/minera|and\b|carbon|basalt/g.test(min)"
            >
              &nbsp;{{ min }}</span
            >
            <button
              class="mineralBtn"
              @click="showModal(min)"
              v-else-if="/\w{3,}/g.test(min)"
            >
              {{ min }}
            </button>

            <span v-else class="min_else">{{ min }}</span>
          </template>
        </div>

        <div
          class="subitem--detail"
          v-if="oneRock.composition_additional.propValue"
        >
          <span>{{ oneRock.composition_additional.propName }}: </span>
          <template
            :key="min"
            v-for="min in replaceString(
              oneRock.composition_additional.propValue,
            )"
          >
            <span
              v-if="
                /minera|ric[ho]|rar|térm|xido|metal|ferro|sul[pf]/g.test(min)
              "
              >&nbsp;{{ min }}</span
            >
            <button
              class="mineralBtn"
              @click="showModal(min)"
              v-else-if="/\w[a-zÀ-ÿ]{3,}/g.test(min)"
            >
              {{ min }}
            </button>
            <span v-else>{{ min }}</span>
          </template>
        </div>

        <div
          class="subitem--detail plus"
          v-if="oneRock.composition_other.propValue"
        >
          <span>{{ oneRock.composition_other.propName }} </span>
          <span>&nbsp;{{ oneRock.composition_other.propValue }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onBeforeMount, computed, ref } from "vue";
import BasePhoto from "@/components/ui/BasePhoto.vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

import BaseDialog from "@/components/ui/BaseDialog.vue";
import MineralGroup from "./MineralGroup.vue";
import SingleMineral from "./SingleMineral.vue";

import NoMatch from "@/components/finder/NoMatch.vue";

const router = useRouter();
const route = useRoute();
const store = useStore();
const isLoading = ref(false);

let position = ref(null);

// minerals
const openModal = ref(false);
const showMineral = ref(null);
let mineralData = ref(null);

onBeforeMount(() => {
  getBasePage();
});

/**
 * listen to params and get oneRock data
 */
async function getBasePage() {
  isLoading.value = !isLoading.value;
  await store.dispatch("rocks/getRockFromParams", route.params.rockId);
  isLoading.value = !isLoading.value;
}

const oneRock = computed(() => {
  return store.getters["rocks/getOneRock"];
});

const noMatch = computed(() => {
  return store.getters["rocks/getNoMatch"];
});

// const getCurrentLanguage = computed(() => {
//   return store.getters.getCurrentLanguage;
// });

function showModal(min) {
  getRockMineral(min);
  mineralData.value = store.getters["minerals/getRockMineral"];
  openModal.value = !openModal.value;
  showMineral.value = min;
  position.value = document.activeElement.getBoundingClientRect();
}
function toggleVisibility() {
  openModal.value = !openModal.value;
  return store.dispatch("minerals/clearRockMineral");
}

function replaceSymbols(inputString) {
  return inputString.replace(/=/g, "");
}

function replaceString(inputString) {
  return inputString
    .replace(
      /(minerais\sde\sóxido\sde\s\w+|minerais\sde\s\w[a-zÀ-ÿ]+|minerais\s\w+|\w+[\s-]?\w+\sminerals|diopsídio\srico\s\w+\s\w+|\w+-rich\s\w+|alkali\sfeldspar|feldspato\salcalino|\w[a-zÀ-ÿ]{3,})/gm,
      "*$1*",
    )
    .split("*")
    .filter(Boolean);
}
// start modal
function getRockMineral(min) {
  return store.dispatch("minerals/getRockMineral", min);
}

function handleCloseOneRock() {
  router.push("/rocks");
}
</script>

<style lang="css" scoped>
.loading {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
.modal {
  position: fixed;
  z-index: 999;
  top: 20%;
  left: 50%;
  width: 300px;
  margin-left: -150px;
}

.subitem--detail {
  display: flex;
  flex-direction: row;
  margin-top: 0.5rem;
}

.content {
  position: relative;
  margin-top: -5vh;
  display: grid;
  /* grid-template-rows: 22vh 78vh; */
  grid-template-rows: 25vh 60vh;
  grid-template-columns: 1fr 1fr;
  width: 90vw;
  height: 95vh;
  background-color: oklch(96.2% 0.018 272.314);
  color: var(--color-grey-4);
  z-index: 1100;
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .content {
    padding-top: 7rem;
    display: flex;
    flex-direction: column;
    height: auto;
  }
}

.title {
  grid-row: 1/2;
  grid-column: 1/-1;

  text-align: center;
  align-content: end;
}

.title_name {
  font-family: var(--font-display);
  text-transform: uppercase;
  font-size: 6rem;
}

.title_detail {
  font-family: var(--font-primary);
  font-size: 4rem;
  text-transform: capitalize;
}
.left {
  grid-row: 2/2;
  grid-column: 1/2;
  display: grid;
  grid-template-rows: 1fr 3fr 2fr;
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .left {
    display: flex;
    justify-content: center;
  }
}

.left--photo {
  grid-row: 2/3;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left--details {
  grid-row: 3/4;
  font-size: 2.5rem;
  background-color: aqua;
  padding-top: 2rem;
  text-align: center;
}

.right {
  grid-row: 2/3;
  grid-column: 2/3;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 3rem;
}

/* 1300px */
@media only screen and (max-width: 81.25em) {
  .right {
    margin-top: 5rem;
  }
}
/* 1025px */
@media only screen and (max-width: 64em) {
  .right {
    margin-top: 10rem;
  }
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .right {
    margin-top: 0px;
  }
}

.right--subitems {
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-size: 2.5rem;
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .right--subitems {
    text-align: center;
  }
}
/* 375px */
@media only screen and (max-width: 23.5em) {
  .right--subitems {
    font-size: 4rem;
  }
}

.subitem--heading {
  font-weight: 600;
  font-size: 3rem;
  background-color: aliceblue;
  width: 100%;
}

/* 375px */
@media only screen and (max-width: 23.5em) {
  .subitem--heading {
    text-transform: capitalize;
    font-size: 3.5rem;
  }
  .subitem--heading + div {
    margin-top: 1rem;
    font-size: 3.5rem;
    text-transform: capitalize;
  }
}
/* 600px */
/* @media only screen and (max-width: 37.5em) {
  .subitem--heading {
    text-align: center;
  }
} */
.mineralBtn {
  font-family: var(--font-primary);
  font-size: 2rem;
  margin-top: 1px;
  margin-left: 4px;
  border-radius: 15px;
  padding-right: 5px;
  padding-left: 5px;
  cursor: pointer;
  color: var(--color-grey-4);
  border: transparent;
  background-color: var(--color-primary-2);
  box-shadow: 2px 2px var(--color-grey-2);
}
.mineralBtn:hover {
  transform: scale(1.1);
}

/* 375px */
@media only screen and (max-width: 23.5em) {
  .mineralBtn {
    text-align: center;
    font-size: 3rem;
    padding-right: 3px;
    padding-left: 3px;
  }
}

/** 1024px */
@media only screen and (max-width: 64em) {
  .subitem--detail {
    display: flex;
    flex-wrap: wrap;
  }
}

/*600px*/
@media only screen and (max-width: 37.5em) {
  .subitem--detail {
    justify-content: center;
  }
}
/* 375px */
@media only screen and (max-width: 23.5em) {
  .subitem--detail {
    padding-left: 4rem;
    font-size: 90%;
  }
  .subitem--detail > span:first-child {
    text-transform: capitalize;
    font-size: 4rem;
  }
  .plus {
    font-size: 90%;
  }
}
.mm {
  text-transform: lowercase;
}
</style>
